module.exports = __webpack_public_path__ + "img/2.494892a2.png";